import { BoxProps } from "@mui/material";
import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import { Column, Row, StackProps } from "@rui/Stack";

type BlockProps = BoxProps & { color: string };

export const Block = styled(({ color: _, ...props }: BlockProps) => (
  <Box {...props} />
))(({ color, onClick }) => ({
  boxSizing: "content-box",
  backgroundColor: color,
  position: "absolute",
  height: "6px",
  cursor: onClick ? "pointer" : "default",
  opacity: 0.7,
  borderWidth: "0px",
  borderColor: color,
  borderStyle: "solid",
  transition: "all 0.075s ease-in-out",
  "&.highlighted, &:hover": {
    borderRadius: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
  },
}));

export const BlocksWrapper = styled((props: StackProps) => (
  <Row variant="center" {...props} />
))({
  width: "100%",
  position: "absolute",
  height: "6px",
  zIndex: "10",
  pointerEvents: "none",
});

type MarkerProps = BoxProps & { color: string; bgcolor: string };

export const Marker = styled(
  ({ color: _, bgcolor: _h, ...props }: MarkerProps) => <Box {...props} />
)(({ color, bgcolor, onClick }) => ({
  boxSizing: "content-box",
  backgroundColor: color,
  position: "absolute",
  height: "6px",
  width: "6px",
  borderRadius: "50%",
  cursor: onClick ? "pointer" : "default",
  opacity: 0.7,
  border: "0px solid",
  borderColor: color,
  transition: "all 0.075s ease-in-out",
  "&.highlighted, &:hover": {
    opacity: 1.0,
    borderWidth: "2px",
    backgroundColor: bgcolor,
    borderColor: color,
    transform: "translateX(-2px)",
  },
}));

export const MarkersWrapper = styled((props: StackProps) => (
  <Row variant="center" {...props} />
))({ width: "100%", position: "relative", height: "8px", mb: 0.5 });

export const Segment = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.shades.neutral[100],
  opacity: 0.4,
  boxSizing: "content-box",
  position: "absolute",
  height: "6px",
  borderRadius: "2px",
}));

export const SegmentsWrapper = styled((props: StackProps) => (
  <Row variant="center" {...props} />
))({
  width: "100%",
  position: "absolute",
  height: "6px",
  zIndex: 0,
  pointerEvents: "none",
});

export const TooltipContent = styled((props: StackProps) => (
  <Column variant="left" {...props} />
))(({ theme }) => ({
  position: "absolute",
  borderRadius: "4px",
  backgroundColor: theme.palette.shades.neutral[800],
  color: "#FFF",
  boxShadow: theme.shadows[2],
  padding: "4px 8px",
  maxWidth: "230px",
}));

export const TooltipContentRow = styled((props: StackProps) => (
  <Row variant="left" spacing={1} {...props} />
))(({ theme }) => ({
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  maxWidth: "100%",
}));

export const TooltipDescription = styled("span")({
  overflow: "hidden",
  display: "inline-block",
  textOverflow: "ellipsis",
});

// mui Divider component doesn't work inside visx tooltips, so make our own
export const TooltipDivider = styled(Box)(({ theme }) => ({
  height: "4px",
  width: "100%",
  marginBottom: "4px",
  borderBottom: `1px solid ${theme.palette.shades.neutral[700]}`,
}));
